<template>
  <v-dialog
    persistent
    v-model="visible"
    :max-width="isMobile ? '480px' : '390px'"
    content-class="request-info tip-success"
    :transition="isMobile ? 'dialog-bottom-transition' : 'fade-transition'"
  >
    <v-card data-test-id="TIP-SUCCESS-DIALOG">
      <!-- <v-toolbar card color="transparent">
          <v-toolbar-title class="subheading font-weight-medium"> </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar> -->

      <v-card-text class="pa-4">
        <SvgIcon
          icon="TipForDriverSuccess"
          width="227"
          height="180"
          :style="{ margin: '0 auto' }"
        />

        <v-card-title>{{ $t('fee.checkout.tip_success_title') }}</v-card-title>
        <span>{{ $t('fee.checkout.tip_success_desc') }}</span>
      </v-card-text>

      <v-card-actions class="px-4 pb-4 pt-0">
        <v-btn block large depressed @click="closeModal" color="accent" data-test-id="CLOSE-BTN">
          {{ $t('fee.checkout.tip_success_close', { seconds: closeModalTimer }) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TipForDriverSuccess',
  data() {
    return {
      visible: false,
      closeModalTimer: 5,
      closeModalInterval: null
    }
  },
  computed: {
    ...mapGetters(['localeSuffix', 'tipInfo'])
  },
  methods: {
    closeModal() {
      if (this.closeModalInterval) clearInterval(this.closeModalInterval)
      this.$store.dispatch('setTipInfo', null)
      this.visible = false
    },
    initCountDownTimer() {
      this.closeModalInterval = setInterval(() => {
        if (this.closeModalTimer === 1) {
          clearInterval(this.closeModalInterval)
          this.$store.dispatch('setTipInfo', null)
          this.visible = false
        }

        this.closeModalTimer -= 1
      }, 1000)
    }
  },
  mounted() {
    if (this.tipInfo && this.tipInfo.success) {
      this.visible = true
      this.initCountDownTimer()
    }
  }
}
</script>

<style lang="scss">
.tip-success {
  .v-toolbar__content {
    padding: 0 16px;
  }

  .v-card {
    text-align: center;

    &__title {
      padding: 32px 8px 8px;
      font-size: 18px;
      line-height: 24px;
      font-weight: 700;
      color: #121619;
      justify-content: center;
    }

    &__text {
      font-size: 14px;
      line-height: 22px;
      color: #7a8189;
    }

    &__text a {
      color: #ff8200;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .v-card__actions {
      .v-btn {
        text-transform: inherit;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .tip-success {
    margin: 0;
    margin-top: auto;
    max-height: 80% !important;
    border-radius: 8px 8px 0 0;
    display: flex;
    overflow: hidden;

    &__body {
      height: calc(100% - 132px);
      overflow-x: hidden;
      overflow-y: auto;
    }

    .v-card {
      display: flex;
      flex-direction: column;

      .v-card__title {
        flex: 1;
        overflow-y: auto;
      }

      .v-card__actions {
        .v-btn {
          margin: 0 !important;
          width: 100% !important;
        }
      }
    }
  }
}
</style>
